import {useCallback} from 'react';
import {isMobile} from "@/Helpers/Function";

/**
 * Универсальный хук для навигации по спискам с помощью стрелок ↑ ↓ и Enter.
 *
 * @param {Object} params
 * @param {Array} params.items - список элементов (массив)
 * @param {number} params.cursor - текущий индекс
 * @param {function} params.setCursor - setState для курсора
 * @param {function} [params.onSelect] - вызывается при смене выделения (стрелками)
 */
export function useSearchNavigation({items, cursor, setCursor, onSelect}) {
    const handleKeyDown = useCallback(
        (e) => {
            if (!items?.length || isMobile()) return;

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                const newCursor = cursor > 0 ? cursor - 1 : items.length - 1;
                setCursor(newCursor);
                onSelect?.(items[newCursor], newCursor);
            } else if (e.key === 'ArrowDown') {
                e.preventDefault();
                const newCursor = cursor < items.length - 1 ? cursor + 1 : 0;
                setCursor(newCursor);
                onSelect?.(items[newCursor], newCursor);
            } else if (e.key === 'Enter') {
                e.preventDefault();
            }
        },
        [items, cursor, setCursor, onSelect]
    );

    return {handleKeyDown};
}
